import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "../../hooks/useAuth";
import { buildCurrentPath, buildPortalLoginUrl } from "../../utils/authRedirect";

/**
 * 受保护的路由组件
 * 如果用户未认证，则重定向到登录页面
 */
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();
    const loginRedirectUrl = buildPortalLoginUrl(buildCurrentPath(location));

    useEffect(() => {
        if (!loading && !isAuthenticated) {
            window.location.replace(loginRedirectUrl);
        }
    }, [isAuthenticated, loading, loginRedirectUrl]);

    // 如果正在加载认证状态，显示加载中
    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                }}
            >
                <Spin size="large" />
            </div>
        );
    }

    // 如果未认证，交给浏览器加载 Portal 登录页
    if (!isAuthenticated) {
        return null;
    }

    // 如果已认证，显示子组件
    return children;
};

export default ProtectedRoute;
